import React from "react";
import { Heart } from "lucide-react";

export const FavoriteButton = ({ messageId, saved, onToggle }) => (
  <button
    onClick={() => onToggle(messageId, saved)}
    data-testid={`favorite-${messageId}`}
    aria-pressed={saved}
    className={`mt-1.5 inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-full border transition-colors duration-200 ${
      saved
        ? "bg-[#E07A5F] border-[#E07A5F] text-[#FDFBF7]"
        : "border-[#2A3B32]/15 text-[#2A3B32] hover:border-[#E07A5F] hover:text-[#E07A5F]"
    }`}
  >
    <Heart size={12} fill={saved ? "currentColor" : "none"} />
    {saved ? "Saved" : "Save"}
  </button>
);

export default FavoriteButton;
